import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import { Link } from 'react-router-dom'
import { IServiceEditStep } from '../../../types/index'
import EntityTabBar from '../../ui/entity/EntityTabBar'
import EntityTabBarItem from '../../ui/entity/EntityTabBarItem'
interface ITabsProps {
  steps: IServiceEditStep[]
  routeProps: RouteComponentProps<any>
}

const ServiceViewTabs = (props: ITabsProps) => {
  const { steps, routeProps } = props

  const isActive = (url: string): boolean => {
    if (url === '') {
      return /(\d+$|edit$|edit\/$)/.test(routeProps.location.pathname)
    }
    return new RegExp(url).test(routeProps.location.pathname)
  }

  return (
    <EntityTabBar>
      {steps.map((it: IServiceEditStep) => {
        const url = it.url ? `/${it.url}` : ''
        return (
          <Link to={`${routeProps.match.url}${url}`} key={`step-${it.url}`}>
            <EntityTabBarItem active={isActive(url)}>{it.title}</EntityTabBarItem>
          </Link>
        )
      })}
    </EntityTabBar>
  )
}

export default ServiceViewTabs



// WEBPACK FOOTER //
// ./src/components/services/view/ServiceViewTabs.tsx